import type { RuleSource } from './rules.js';

export const INTERPRETATION_SOURCE_REGISTRY_VERSION = 'SOURCE-REGISTRY@0.2' as const;

export const SRC_ZWDS_BOOK_001: RuleSource = Object.freeze({
  sourceId: 'SRC-ZWDS-BOOK-001',
  sourceType: 'public_domain_text',
  title: '紫微斗數全書',
  sourceUrl: 'https://zh.wikisource.org/zh-hant/%E7%B4%AB%E5%BE%AE%E6%96%97%E6%95%B8%E5%85%A8%E6%9B%B8/%E5%85%A8%E8%A6%BD',
  citation: '卷一・太微賦／形性賦／諸星問答論；卷二・十二宮與四化相關條目；卷三・談星要論／論諸星同垣各司所宜；Wikisource public-domain transcription entry',
  license: 'Public Domain (historical work)',
  confidence: 'verified',
});

export const REGISTERED_INTERPRETATION_SOURCES: readonly RuleSource[] = Object.freeze([SRC_ZWDS_BOOK_001]);
const SOURCE_BY_ID: ReadonlyMap<string, RuleSource> = new Map(REGISTERED_INTERPRETATION_SOURCES.map((source) => [source.sourceId, source] as const));
export function registeredInterpretationSource(sourceId: string): RuleSource | undefined { return SOURCE_BY_ID.get(sourceId); }
export function isRegisteredInterpretationSource(sourceId: string): boolean { return SOURCE_BY_ID.has(sourceId); }
